import React, { useState } from 'react';
import './Accordion.css';

const AccordianItem: React.FC<{ title: string; content: string }> = ({
  title,
  content,
}) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="accordion-item">
      <div className="accordion" onClick={() => setIsActive(!isActive)}>
        <div>{title}</div>
      </div>
      {isActive && <div className="panel">{content}</div>}
    </div>
  );
};

export default AccordianItem;
